import { apiGet } from './client';

export type AuditLogRow = {
  id: number;
  at: string;
  actorEmail: string;
  actorScope: 'internal' | 'external' | 'system' | string;
  actorIp: string | null;
  action: string;
  target: string | null;
  before: unknown;
  after: unknown;
  requestId: string | null;
};

export type AuditLogFilter = {
  action?: string;
  actorEmail?: string;
  actorScope?: Array<'internal' | 'external' | 'system'>;
  target?: string;
  fromDate?: string;
  toDate?: string;
  cursor?: string;
  limit?: number;
};

function buildQuery(f: AuditLogFilter): string {
  const p = new URLSearchParams();
  if (f.action) p.set('action', f.action);
  if (f.actorEmail) p.set('actorEmail', f.actorEmail);
  f.actorScope?.forEach((s) => p.append('actorScope', s));
  if (f.target) p.set('target', f.target);
  if (f.fromDate) p.set('fromDate', f.fromDate);
  if (f.toDate) p.set('toDate', f.toDate);
  if (f.cursor) p.set('cursor', f.cursor);
  if (f.limit) p.set('limit', String(f.limit));
  return p.toString();
}

export const auditLogApi = {
  page: (filter: AuditLogFilter) => {
    const qs = buildQuery(filter);
    return apiGet<{
      rows: AuditLogRow[];
      nextCursor: string | null;
      hasMore: boolean;
    }>(`/api/audit-log/page${qs ? `?${qs}` : ''}`);
  },
  actions: () => apiGet<{ actions: string[] }>(`/api/audit-log/actions`),
};
